import { memo } from "react";
import { Typography } from "@mui/material";

import NavGroup from "./NavGroup";
import { useMenuItems } from "../../../../menu-items";
import AddEditFolderModal from "../../../../components/modal/AddEditFolderModal";
import { useSelector, useDispatch } from "../../../../store";
import { toggleAddEditFolder } from "../../../../store/slices/menu";

const MenuList = () => {
  const menuItems = useMenuItems();
  const dispatch = useDispatch();
  const { isAddEditFolderVisible } = useSelector((state) => state.menu);

  const navItems = menuItems.items.map((item) => {
    switch (item.type) {
      case "group":
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return (
    <>
      {navItems}
      <AddEditFolderModal
        isVisible={isAddEditFolderVisible}
        onDismiss={() => dispatch(toggleAddEditFolder(false))}
      />
    </>
  );
};

export default memo(MenuList);
